import actions from './actions';

const RepairSelectModule = {
  namespaced: true,
  state() {
    return {};
  },
  actions,
};

export default RepairSelectModule;
